import { render } from "./text-and-percentile.html?vue&type=template&id=3be1e82c&scoped=true&ts=true&external"
import script from "./text-and-percentile.ts?vue&type=script&lang=ts&external"
export * from "./text-and-percentile.ts?vue&type=script&lang=ts&external"

import "./text-and-percentile.scss?vue&type=style&index=0&id=3be1e82c&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be1e82c"]])

export default __exports__